import React from 'react'
import Segmented from 'antd/es/segmented'
import type { SegmentedProps, SegmentedValue } from 'antd/es/segmented'
import SizeContext from 'antd/es/config-provider/SizeContext'

export const IdeyaSegmented = <
  ValueType extends SegmentedValue = SegmentedValue,
>({
  size,
  ...props
}: SegmentedProps<ValueType>) => {
  const contextSize = React.useContext(SizeContext)
  return <Segmented<ValueType> size={size ?? contextSize} {...props} />
}
